import ListWidgetMixin from "../mixins/ListWidgetMixin";

Vue.asyncComponent('ak-list', {
    mixins: [ListWidgetMixin],
    props: {
        items: {
            type: Array,
            required: false,
        },
        showDots: {
            type: Boolean,
            required: false,
            default: false
        },
        showNumbers: {
            type: Boolean,
            required: false,
            default: false
        },
        showLines: {
            type: Boolean,
            required: false,
            default: false
        },
        hasPadding: {
            type: Boolean,
            required: false,
            default: false
        },
        paramsForCallback: {
            type: Object,
            required: false,
            default: () => {}
        }
    },
}, 'layout/ak-list.html');